import { render } from "./searchPlayers.vue?vue&type=template&id=3aa9dba0"
import script from "./searchPlayers.vue?vue&type=script&lang=js"
export * from "./searchPlayers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__